import styledSC from 'styled-components';
import { Alert, AlertTitle } from '@mui/material';

import { GeneralButton } from '../../../../../components/Button/ActionButtons/styles';
import colors from '../../../../../styles/colors';

export const SessionBannerAlert = styledSC(Alert)`
  & .MuiAlert-action {
    align-items: center;
    padding-top: 0;
    margin-top: 0;
  }
`;

export const SessionBannerTitle = styledSC(AlertTitle)`
  margin-bottom: ${({ $hasDescription }) => ($hasDescription ? '4px' : '0')};
`;

export const ClearButton = styledSC(GeneralButton)`
  border: 1px solid ${colors.shades.danger4};
  color: ${colors.shades.danger3};
  background: ${colors.shades.danger2};
  gap: 8px;
  &:hover {
    background: ${colors.shades.danger4};
  }
`;
